module.exports = "././fonts/a2647ffe169bbbd94a3238020354c732.woff2";


//////////////////
// WEBPACK FOOTER
// ../fonts/roboto-v16-latin-regular.woff2
// module id = 1087
// module chunks = 0